<template>
	<div id="app">
		<!-- <transition name="router-fade" mode="out-in">
			<keep-alive>
			    <router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
    	</transition>
    	<transition name="router-fade" mode="out-in">
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</transition> -->
		<router-view></router-view>
        <Loading v-show="showLoading"></Loading>
    </div>
</template>
<script>
import Loading from "@/components/Loading";
export default {
	name: 'App',
	data () {
		return {
			showLoading:false,		
		}
	},
	methods: {
	},
	components: {
		Loading
	},
	mounted() {
		// 禁用alert
		window.alert = function(){}
	},
}
</script>

<style lang='scss'>
@import './style/common';
	.router-fade-enter-active, .router-fade-leave-active {
	  	transition: opacity .3s;
	}
	.router-fade-enter, .router-fade-leave-active {
	  	opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue